export default __webpack_public_path__ + "static/media/upButtonArrow.0e7e4911.svg";